import {useCallback, useMemo} from "react";
import {RazorpayClient} from "./razorpay-client";
import {RazorpayOptions} from "./@types/RazorpayOptions";

/**
 * Custom hook to open a Razorpay payment modal.
 * @param {RazorpayOptions} options - Configuration options for the Razorpay payment.
 * @returns A function that triggers the payment flow when called.
 */
export function useRazorpay(options: RazorpayOptions) {
  const isClient = useMemo(() => typeof window !== "undefined", []);
  return useCallback(async () => {
    if (!isClient) return;
    await RazorpayClient.openPayment(options);
  }, [options]);
}
